var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"campaign-badge py-1 px-3 text-nowrap",style:(_vm.style),attrs:{"data-id":_vm.id}},[_c('font-awesome-icon',{attrs:{"icon":"tag"}}),_vm._v("  "),_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b26e46b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/Badge.vue
// module id = 8rMq
// module chunks = 49 111